module.exports = __webpack_public_path__ + "img/arrow-right-small.88b18847.svg";